import {DataTable} from "../DataTable/DataTable";
import {WellEntity} from "@ots-frontend/ots-data";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {useTranslation} from "react-i18next";
import {Anchor} from "@mantine/core";
import {Link} from "react-router-dom";
import {useWellDataTableFilter} from "../WellDataTable/useWellDataTableFilter";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";
import {usePagination} from "../DataTable/usePagination";
import {getColumnFilterProps} from "../DataTable/useDataTableFilter";
import {sortBy} from "lodash";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {EntityAnchor} from "../../anchor/EntityAnchor/EntityAnchor";
import {useMemo} from "react";

const EMPTY_ARRAY: WellEntity[] = []

export type WellDataTableProps = EntityDataTableProps<WellEntity>

export const WellDataTable = (props: WellDataTableProps) => {
  const {
    records: wells = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {filteredRecords, filterConfig} = useWellDataTableFilter({
    records: wells
  })

  const sortConfig = useMemo(() => {
    return {
      "name": {
        sortAll: (records, columnAccessor) => {
          return sortBy(records, [function (record) {
            return record.name?.toLowerCase()
          }])
        }
      },
    }
  }, [])

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: filteredRecords,
    sortStatus: {columnAccessor: 'name', direction: 'asc'},
    sortConfig: sortConfig,
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          ...getColumnFilterProps(filterConfig, "name"),
          title: t("table.entity.well.column.name", "Name"),
          accessor: 'name',
          width: 100,
          sortable: true,
          render: (record) => (
            <EntityAnchor value={record} />
          ),
        },
        {
          ...getColumnFilterProps(filterConfig, "stage"),
          title: t("table.entity.well.column.stage", "Stage"),
          accessor: 'wellStageCode',
          width: 100,
          sortable: true,
        },
        {
          ...getColumnFilterProps(filterConfig, "site"),
          title: t("table.entity.well.column.site", "Site"),
          accessor: 'siteName',
          width: 100,
          sortable: true,
          render: ({siteId, siteName}) => (
            siteId ? <DefaultText value={siteName}/> : undefined
          )
        },
      ]}
    />
  )
}
